import React from "react";
import { ChevronRight } from "lucide-react";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";

interface ButtonCardProps {
  text: string;
  number?: number;
  icon: string;
  color: string;
  navigateTo: string;
  queryParam?: string;
}

const ButtonCard: React.FC<ButtonCardProps> = ({
  text,
  number,
  icon,
  color,
  navigateTo,
  queryParam,
}) => {
  const navigate = useNavigate();
  return (
    <div
      className={`rounded-[15px] bg-main box-border w-full overflow-hidden flex flex-col items-start justify-start py-[13px] px-[17px] text-left border-2 border-solid`}
      style={{ borderColor: color, boxShadow: `0px 2px 0px ${color}` }}
    >
      <div className="grid grid-cols-12 items-center w-full gap-3">
        <div className="col-span-1 flex items-center justify-center">
          <img
            className="w-6 h-6 overflow-hidden shrink-0"
            alt="Icon"
            src={icon}
          />
        </div>
        <div className="col-span-6 flex items-center justify-start">
          <div className="leading-[17px] font-medium">
            <p className="m-0">{text}</p>
          </div>
        </div>
        <div
          className="col-span-3 flex items-center justify-center text-[36px] leading-[40px] font-semibold"
          style={{ color: color }}
        >
          {number}
        </div>
        <div className="col-span-2 flex items-center justify-center">
          <Button
            variant="icon"
            size="icon"
            className="rounded-full border-none"
            style={{ backgroundColor: color }}
            onClick={() => navigate(`${navigateTo}?duration=${queryParam}`)}
          >
            <ChevronRight className="text-white" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ButtonCard;
